import React, { useEffect, useState, useRef } from 'react';
import Typography from '@mui/material/Typography';
import TextField from "@mui/material/TextField";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import DoneIcon from '@mui/icons-material/Done';
import { useMediaQuery } from 'react-responsive';
import Grid from '@mui/material/Grid';
import LoupeItemHeaderComponent from './LoupeItemHeaderComponent';
import uuid from 'react-uuid';
import Slider from '@mui/material/Slider';

import { LocalizationContext } from '../../App';



const LoupeChipConditionalSliderItem = props => {

    const isMobileView = useMediaQuery({        
        query: '(max-width: 900px)'
    });
    const isWideView = useMediaQuery({
        query: '(min-width: 1200px)'
    });
    const isNarrowDesktop = useMediaQuery({
        query: '(min-width: 900px)'
    });

    const callbackHandler = props.callbackHandler;
    const currentItem = props.currentItem;

    const [state, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);


    const [ chipValues ] = useState( currentItem.selectedValues );
    //const [ value, setValue ] = React.useState(currentItem.scales);

    const [ value ] = React.useState(currentItem.scales);

    var renderedElements = 0;

    
    const itemRevalidation = () => {       

        // take care to validate content of this item. If no chips selected, it fulfills required interaction.
        // otherwise, for all items, a likert scale item must be selected.
        var hadError = false;
        if( currentItem.selectedValues.length == 0 ) {
            currentItem.validator.touched();
        } else {        
            
            currentItem.selectedValues.map(sel => {
                var origIdx = currentItem.itemOrder.indexOf(sel);
                if( currentItem.scales[origIdx].selectedValue == "" ) {
                    hadError = true;
                }                         
            });

            if(hadError){
                currentItem.validator.untouch();
            } else {
                currentItem.validator.touched();
            }
        }
        return hadError;
    }

    itemRevalidation();
    
    


    const isInResultset = value => {
        return currentItem.selectedValues.includes(value);
    }

    
    const handleChipClick = (chipValue, item) => {
        
        if(isInResultset(chipValue)) {

            var idx = currentItem.selectedValues.indexOf(chipValue);
            currentItem.selectedValues.splice(idx, 1);
            var origIdx = currentItem.itemOrder.indexOf(chipValue);            
            
            value[origIdx].setValue("");            

        } else {
            currentItem.selectedValues.push(chipValue);
        }

        if(currentItem.validator.instantRevalidation) {
            itemRevalidation();
            currentItem.validator.revalidate();
        }

        forceUpdate();
    }

    
    const myChange = (event, idx, obj) => {       
        obj.setValue(event.target.value);
        
        if(currentItem.validator.instantRevalidation) {
            itemRevalidation();
            currentItem.validator.revalidate();
        }
        
        forceUpdate();
       
    };
    
    


    return (

        <LocalizationContext.Consumer>
            { ({strings}) => 

            <div className="text-start mb-4">

                <LoupeItemHeaderComponent currentItem={currentItem} />
                <Grid container>
                    <Grid item xs={12} className="mb-5">
                       
                        { currentItem.choices.map(c => {
                            
                            const variant = (isInResultset(c['_attributes']['export-label'])) ? 'filled' : 'filled';
                            
                            return(
                                <Chip 
                                style={{margin : '3px'}}
                                onClick={(e) => handleChipClick(c['_attributes']['export-label'], e)}
                                value={c['_attributes']['export-label']} 
                                {...( isInResultset(c['_attributes']['export-label']) ? { color : 'primary'} : {})}
                                variant={variant}
                                key={`chip_${c['_attributes']['export-label']}`} 
                                label={c['_attributes']['label']}/>
                                )
                            }) }
                            
                             
                    </Grid> 
                </Grid>
        
                { isMobileView == false ? 
                (
                    <>                    

                        <Grid container>

                            <Grid item xs={12}>
                                
                                <Grid container spacing={2} justifyContent="center">

                                    { value.map( (s, idx, arr) => {
                                    
                                        // we have to keep track about the number of items rendered, as this now determines in comparison to selection 
                                        var isLastItem = (renderedElements == chipValues.length - 1) ? true : false;
                                        var printInvisibleLabels = ( !isLastItem && currentItem.units == 0) ? true : false;
                                                                                                     

                                        if( !isInResultset(s.exportLabel) ){ 
                                            return(
                                                <React.Fragment key={s.id + "_wrap"}></React.Fragment>                                                   
                                            );
                                        } else {
                                            renderedElements += 1;
                                            return ( 

                                                <React.Fragment key={s.id + "_wrap"}>
                                                
                                                    <Grid item xs={ isWideView == true ? 4 : 4 } justifyContent={"center"}>
                                                        {s.label}                                                      
                                                    </Grid>

                                                    <Grid item xs={ isWideView == true ? 7 : 7 } justifyContent={"center"}>                                                   
                                                        <Slider                     
                                                            {...( currentItem.sliderType == "discrete" ? currentItem.lockMarks == false ? {  step : currentItem.increment} : { step : null} : {} )}
                                                            marks={currentItem.marks}
                                                            value={value[idx].selectedValue}
                                                            onChange={(event) => myChange(event, idx, s)}
                                                            track={false}
                                                            min={currentItem.minValue}
                                                            max={currentItem.maxValue}
                                                            valueLabelDisplay={currentItem.labelDisplayProperty} />                                                   
                                                    </Grid>

                                                    <Grid item xs />
                                                    
                                                </React.Fragment>
                                            );
                                        }
                                    
                                    
                                    })}

                                
                                </Grid>                        

                            </Grid>

                        </Grid>     
                
                    </>
                ) : (
                    <>
                    <Grid container spacing={2}>
                        <Grid item xs/>
                            <Grid item xs={10}>     

                                    { value.map( (s, idx, arr) => {
                                        if( !isInResultset(s.exportLabel) ) {
                                            return(<React.Fragment key={s.id + "_wrap"}></React.Fragment>);

                                        } else {                                                    
                                            renderedElements += 1;                                                                                                            
                                            return (

                                                <Grid item xs={12} key={s.id + "_wrap"}>
                                                    
                                                        <p className="mb-4" />
                                                        <FormLabel>{s.label}</FormLabel> 

                                                        <Slider                     
                                                            {...( currentItem.sliderType == "discrete" ? currentItem.lockMarks == false ? {  step : currentItem.increment} : { step : null} : {} )}
                                                            marks={currentItem.marks}
                                                            value={value[idx].selectedValue}
                                                            onChange={(event) => myChange(event, idx, s)}
                                                            track={false}
                                                            min={currentItem.minValue}
                                                            max={currentItem.maxValue}
                                                            valueLabelDisplay={currentItem.labelDisplayProperty} />                                                         
                            
                                                </Grid>                                        

                                            );
                                        }

                                    }) }
                            </Grid>
                        <Grid item xs/>
                    </Grid>
                        

                    
                    
                    </>
                )} 
                                    
            </div>
            }
        </LocalizationContext.Consumer>
    );

}
export default LoupeChipConditionalSliderItem;